import { SVGProps } from 'react';
const SvgTextAlignLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 18h10M4 14h16M4 10h10M4 6h16"
    />
  </svg>
);
export default SvgTextAlignLeft;
